import { HeartHandshake, Sparkles, Globe2, Users2 } from "lucide-react";

/**
 * Inclusion section — welcoming, premium, trauma-informed.
 * Flags image lives only at the bottom of the page (footer).
 */
export function InclusionSection({ variant = "default" }) {
  return (
    <section
      data-testid="inclusion-section"
      className={`${
        variant === "soft" ? "bg-white" : "bg-[#F8FAFC]"
      } border-y border-slate-100`}
    >
      <div className="container-app py-20 lg:py-28 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 reveal">
          <p className="eyebrow">A place for everyone</p>
          <h2 className="font-heading mt-4 text-3xl sm:text-4xl lg:text-5xl text-[#0A2540] leading-tight">
            All are welcome here.
            <br />
            <span className="text-[#2E8B8B]">Without exception.</span>
          </h2>
          <p className="mt-6 text-base text-slate-600 leading-relaxed max-w-xl">
            We acknowledge the First Peoples on whose lands we walk, and we stand alongside
            LGBTQIA+, gender-diverse, and culturally-diverse communities. Our doors,
            our programs, and our care are open to everyone — no exceptions, no conditions.
          </p>

          <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3 text-sm text-slate-600">
            {[
              "Trauma-informed practice",
              "Cultural respect & humility",
              "Gender-affirming care",
              "Anti-racist, anti-discrimination",
            ].map((b) => (
              <li key={b} className="flex items-center gap-3">
                <span className="h-1.5 w-1.5 rounded-full bg-[#2E8B8B]" />
                {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5 reveal">
          <div className="grid grid-cols-2 gap-4">
            {[
              { icon: HeartHandshake, label: "Welcoming care" },
              { icon: Globe2, label: "Culturally inclusive" },
              { icon: Users2, label: "Community first" },
              { icon: Sparkles, label: "Dignity, always" },
            ].map((v) => (
              <div key={v.label} className="rounded-3xl bg-white border border-slate-100 p-6 shadow-sm">
                <span className="grid h-11 w-11 place-items-center rounded-2xl bg-[#E6F0F2] text-[#2E8B8B]">
                  <v.icon className="h-5 w-5" />
                </span>
                <p className="font-heading mt-5 text-base text-[#0A2540] leading-snug">{v.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default InclusionSection;
